export { default } from '../components/pages/Travel';
